import eventBus from "@/app/eventBus";
import { PS_EVENTS } from "@/app/ps-events";
import { useEffect, useState } from "react";

export const useMapView = () => {
	const isBrowser = typeof window !== 'undefined'
	const getSessionStorageMapView = isBrowser && sessionStorage.getItem('hotelsMapView')
	const getSessionStorageListView = isBrowser && sessionStorage.getItem('hotelsListView')
	const initialMapView = getSessionStorageMapView === '1'
	// Default the results page to the hotels list (not the split map view) unless
	// the user explicitly toggled the view earlier this session. Previously desktop
	// (>1279px) opened on the map by default; product wants the list shown first.
	const initialListView = getSessionStorageListView ? getSessionStorageListView === '1' : true
	const [isFullScreenMap, setFullScreenMap] = useState(initialMapView);
	const [isListView, setListView] = useState(initialListView);

	useEffect(() => {
		//listen to full map view event
		const handleSetFullMapView = (checked: boolean) => {
			sessionStorage.setItem('hotelsMapView', checked ? '1' : '0')
			setFullScreenMap(checked)
		}
		const handleSetListView = (checked: boolean) => {
			sessionStorage.setItem('hotelsListView', checked ? '1' : '0')
			setListView(checked)
		}

		eventBus.subscribe(
			PS_EVENTS.FULL_SCREEN_MAP,
			handleSetFullMapView
		)

		eventBus.subscribe(
			PS_EVENTS.LIST_VIEW,
			handleSetListView
		)

		// Window resize handler:
		const THRESHOLD = 1279
		let prevWidth = window.innerWidth
		const handleResize = () => {
			const currentWidth = window.innerWidth
			if (prevWidth > THRESHOLD && currentWidth <= THRESHOLD) {
				handleSetListView(true)
			}
			prevWidth = currentWidth
		}
		window.addEventListener('resize', handleResize)

		return () => {
			window.removeEventListener('resize', handleResize)
			eventBus.unsubscribe(
				PS_EVENTS.FULL_SCREEN_MAP,
				handleSetFullMapView
			)
			eventBus.unsubscribe(
				PS_EVENTS.LIST_VIEW,
				handleSetListView
			)
		}
	}, [])

	return { isFullScreenMap, isListView, setListView }
}